import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'stripHtml', standalone: true })
export class StripHtmlPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  public transform(value: string, allowedTags: string[] = [], returnAsSafeHtml = false): any {
    if (!value) {
      return '';
    }

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = value;

    if (allowedTags.length > 0) {
      const lowerCaseAllowedTags = allowedTags.map((tag) => tag.toLowerCase());

      const nodes = tempDiv.querySelectorAll('*');
      nodes.forEach((node) => {
        if (!lowerCaseAllowedTags.includes(node.nodeName.toLowerCase())) {
          node.parentNode?.removeChild(node);
        }
      });
    }

    if (returnAsSafeHtml) {
      return this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML);
    }

    return tempDiv.textContent;
  }
}
